import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { DataContainer } from '../../components/DataContainer';
import { updateJob } from '../../store/knownDataSlice';
import { isInPast } from '../../util';
import { unwrapResult } from '@reduxjs/toolkit';
import DriversListSelector from '../../components/DriversListSelector';
import BusesListSelector from '../../components/BusesListSelector';


function UpdateJob({ id }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    const [ driver, setDriver ] = useState("");
    const [ extraDrivers, setExtraDrivers ] = useState([]);
    const [ bus, setBus ] = useState("");
    const [ extraBuses, setExtraBuses ] = useState([]);

    async function onUpdate() {
        // Check if extra drivers are unique
        const extraDriversSet = new Set(extraDrivers);
        if(extraDriversSet.size !== extraDrivers.length) {
            toast.error("Korduvad juhid!");
            return;
        }
        if(extraDrivers.includes(driver)) {
            toast.error("Korduvad juhid!");
            return;
        }

        // Check if extra buses are unique
        const extraBusesSet = new Set(extraBuses);
        if(extraBusesSet.size !== extraBuses.length) {
            toast.error("Korduvad bussid!");
            return;
        }
        if(extraBuses.includes(bus)) {
            toast.error("Korduvad bussid!");
            return;
        }



        await unwrapResult(await dispatch(updateJob({
            id,
            driver,
            bus,
            extraDrivers,
            extraBuses,
        })));

        toast.success("Töö uuendatud!");
    }

    useEffect(() => {
        setDriver(data["driver_id"]);
        setBus(data["bus_id"]);
        setExtraDrivers(data["job_extra_drivers"] ? JSON.parse(data["job_extra_drivers"]) : []);
        setExtraBuses(data["job_extra_buses"] ? JSON.parse(data["job_extra_buses"]) : []);
    }, [data]);



    if(!data) {
        return;
    }

    if(!data["job_query_id"]) {
        return;
    }

    return (
        <>
            <hr />

            <DataContainer actionType={"knownData/updateJob"}>
                <div className="column g32">
                    <h2>Muuda juhti ja bussi</h2>

                    <div className="column g8">
                        <p>Juht</p>
                        <DriversListSelector
                            driver={driver}
                            setDriver={setDriver}
                            extraDrivers={extraDrivers}
                            setExtraDrivers={setExtraDrivers}
                        />
                    </div>

                    <div className="column g8">
                        <p>Buss</p>
                        <BusesListSelector
                            bus={bus}
                            setBus={setBus}
                            extraBuses={extraBuses}
                            setExtraBuses={setExtraBuses}
                        />
                    </div>

                    <p style={{ color: '#888', textAlign: 'center', width: '100%' }}>Salvesta vajutades saadetakse juhile ja kliendile e-kirja teavitus.</p>

                    <button onClick={onUpdate}>Salvesta</button>

                </div>
            </DataContainer>
        </>
    );
}

export default UpdateJob;